import React, { useState } from 'react';
import { TrendingUp, Star, Award, ArrowUpRight, Trophy } from 'lucide-react';

const publicPath = (p) => (process.env.PUBLIC_URL || '') + p;

const stories = [
  {
    img: publicPath('/assets/success/s1.jpeg'),
    name: 'Ishita',
    grade: 'Class 6 • CBSE',
    subject: 'Mathematics',
    before: 58,
    after: 92,
    duration: '4 months',
    achievement: 'Class Topper in Maths',
    story:
      'Ishita used to be scared of word problems. With her Pikachu didi, she now solves them faster than her classmates and looks forward to every session.',
    accent: '#F4B93E',
    icon: Trophy,
  },
  {
    img: publicPath('/assets/success/s2.jpeg'),
    name: 'Riya',
    grade: 'Class 10 • CBSE',
    subject: 'Science & Maths',
    before: 65,
    after: 94,
    duration: '6 months',
    achievement: 'Boards 94% aggregate',
    story:
      'A steady daily plan, weekly mock tests and doubt-clearing over WhatsApp turned Riya\u2019s board year from stressful into confident.',
    accent: '#4FB3B8',
    icon: Award,
  },
  {
    img: publicPath('/assets/success/s3.jpeg'),
    name: 'Ahaan',
    grade: 'Class 8 • ICSE',
    subject: 'Physics & Maths',
    before: 62,
    after: 89,
    duration: '5 months',
    achievement: 'Olympiad Rank 47',
    story:
      'A little push at the right time and Aryan discovered how much he actually enjoys Physics. He now attempts NSO papers on his own.',
    accent: '#2C3E50',
    icon: Star,
  },
  {
    img: publicPath('/assets/success/s4.jpeg'),
    name: 'Vihaan',
    grade: 'Class 3 • CBSE',
    subject: 'English & Reading',
    before: 55,
    after: 91,
    duration: '3 months',
    achievement: 'Started reading chapter-books',
    story:
      'From struggling with paragraph reading to finishing his first chapter book \u2014 Vihaan\u2019s new confidence has made his parents beam with pride.',
    accent: '#E64B2B',
    icon: TrendingUp,
  },
  {
    img: publicPath('/assets/success/s5.jpeg'),
    name: 'Kabir',
    grade: 'Class 2 • CBSE',
    subject: 'All Subjects',
    before: 70,
    after: 96,
    duration: '4 months',
    achievement: 'Consistent A+ in unit tests',
    story:
      'Regular schedule, friendly tutor, and colourful worksheets have turned homework time from tears into giggles for Kabir.',
    accent: '#7BB7DC',
    icon: TrendingUp,
  },
  {
    img: publicPath('/assets/success/s6.jpeg'),
    name: 'Aditya',
    grade: 'Class 7 • CBSE',
    subject: 'Maths & Science',
    before: 60,
    after: 90,
    duration: '5 months',
    achievement: 'Birthday-week board topper',
    story:
      'Aditya asked for a maths tutor as his birthday gift. Five months later, he\u2019s the one his friends turn to for help.',
    accent: '#4FB3B8',
    icon: Trophy,
  },
  {
    img: publicPath('/assets/success/s7.jpeg'),
    name: 'Aanya',
    grade: 'Class 3 • CBSE',
    subject: 'English & Maths',
    before: 66,
    after: 93,
    duration: '4 months',
    achievement: 'Best Handwriting Award',
    story:
      'Weekly reading circles and a lot of encouragement helped Aanya go from shy in class to raising her hand first.',
    accent: '#E64B2B',
    icon: Star,
  },
  {
    img: publicPath('/assets/success/s8.jpeg'),
    name: 'Saanvi',
    grade: 'Class 7 • ICSE',
    subject: 'Science',
    before: 68,
    after: 95,
    duration: '6 months',
    achievement: 'Science fair Gold medal',
    story:
      'Saanvi\u2019s curiosity finally got the runway it deserved. Her school project on renewable energy won gold this year.',
    accent: '#F4B93E',
    icon: Award,
  },
  {
    img: publicPath('/assets/success/s9.jpeg'),
    name: 'Aarav',
    grade: 'Class 5 • CBSE',
    subject: 'Maths',
    before: 63,
    after: 94,
    duration: '5 months',
    achievement: 'Perfect score in Term 2',
    story:
      'Aarav went from dodging maths practice to asking for extra sums. His mother says the transformation feels like magic.',
    accent: '#2C3E50',
    icon: TrendingUp,
  },
  {
    img: publicPath('/assets/success/s10.jpeg'),
    name: 'Vivaan',
    grade: 'Class 4 • CBSE',
    subject: 'English & EVS',
    before: 59,
    after: 91,
    duration: '4 months',
    achievement: 'Class monitor after mid-terms',
    story:
      'A calmer study routine and gentle mentorship pulled Vivaan\u2019s marks up and made him a role-model for his classmates.',
    accent: '#7BB7DC',
    icon: Star,
  },
];

function StoryCard({ s, active, onClick }) {
  const Ic = s.icon;
  return (
    <button
      type="button"
      onClick={onClick}
      className={`text-left w-full bg-white border-2 border-[#2C3E50] rounded-2xl overflow-hidden transition-transform ${active ? 'paper-shadow scale-[1.01]' : 'hover:-translate-y-0.5 paper-shadow-sm'}`}
    >
      <div className="relative">
        <img src={s.img} alt={s.name} loading="lazy" className="w-full h-40 object-cover object-top" />
        <div
          className="absolute top-2 left-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[9px] font-black uppercase tracking-widest text-white border-2 border-white"
          style={{ background: s.accent }}
        >
          <Ic size={10} strokeWidth={3} /> Success
        </div>
      </div>
      <div className="p-3">
        {/* Aayan */}
        <div className="font-black text-[#2C3E50] leading-tight" style={{ fontFamily: 'Fraunces, serif' }}>
          {s.name}
        </div>
        <div className="text-[10px] font-black uppercase tracking-widest text-[#2C3E50]/60">{s.grade}</div>
        <div className="mt-2 flex items-baseline gap-1">
          <span className="text-xs font-bold text-[#2C3E50]/70 line-through">{s.before}%</span>
          <ArrowUpRight size={12} className="text-[#E64B2B]" strokeWidth={3} />
          <span className="text-base font-black" style={{ color: s.accent, fontFamily: 'Fraunces, serif' }}>{s.after}%</span>
        </div>
      </div>
    </button>
  );
}

export default function SuccessStories() {
  const [idx, setIdx] = useState(0);
  const s = stories[idx];
  const Ic = s.icon;

  return (
    <section id="success" className="py-16 lg:py-24 bg-white border-y-2 border-[#2C3E50] relative overflow-hidden">
      <div className="absolute inset-0 grid-dots opacity-30 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 relative">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="inline-flex items-center gap-2 bg-[#F4B93E] text-[#2C3E50] px-4 py-1.5 rounded-full text-xs font-black uppercase tracking-widest border-2 border-[#2C3E50]">
            <Trophy size={12} strokeWidth={3} /> Success Stories
          </span>
          <h2 className="mt-4 text-3xl lg:text-5xl font-black text-[#2C3E50] leading-[1.05]">
            Report cards that made <span className="text-[#E64B2B]">parents cry (happy tears).</span>
          </h2>
          <p className="mt-4 text-[#2C3E50]/75 text-lg">
            Every Pikachuian gets a personal plan, weekly reviews, and a tutor who truly cheers for them.
          </p>
        </div>

        {/* Featured story */}
        <div className="grid lg:grid-cols-12 gap-8 items-stretch">
          <div className="lg:col-span-5 relative">
            <div className="relative bg-[#FFF8EC] rounded-3xl border-2 border-[#2C3E50] overflow-hidden paper-shadow">
              <img src={s.img} alt={s.name} className="w-full h-[460px] object-cover object-top" />
              <div className="absolute top-4 left-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-black uppercase tracking-widest text-white border-2 border-white" style={{ background: s.accent }}>
                <Ic size={13} strokeWidth={3} /> {s.achievement}
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col">
            <div className="bg-[#FFF8EC] border-2 border-[#2C3E50] rounded-3xl p-6 lg:p-8 paper-shadow-yellow flex-1">
              <div className="flex items-start justify-between gap-4">
                <div>
                  <div className="text-3xl lg:text-4xl font-black text-[#2C3E50]" style={{ fontFamily: 'Fraunces, serif' }}>
                    {s.name}
                  </div>
                  <div className="text-sm font-black uppercase tracking-widest text-[#2C3E50]/70">
                    {s.grade} &middot; {s.subject}
                  </div>
                </div>
                <div className="hidden sm:flex items-center gap-1 text-[#F4B93E]">
                  {['s1', 's2', 's3', 's4', 's5'].map((k) => (
                    <Star key={k} size={16} fill="#F4B93E" strokeWidth={0} />
                  ))}
                </div>
              </div>

              {/* Score jump */}
              <div className="mt-6 grid grid-cols-3 gap-3">
                <div className="bg-white border-2 border-[#2C3E50] rounded-xl p-3 text-center">
                  <div className="text-[10px] font-black uppercase tracking-widest text-[#2C3E50]/60">Before</div>
                  <div className="text-2xl font-black text-[#2C3E50]/60 line-through" style={{ fontFamily: 'Fraunces, serif' }}>
                    {s.before}%
                  </div>
                </div>
                <div className="bg-white border-2 border-[#2C3E50] rounded-xl p-3 text-center">
                  <div className="text-[10px] font-black uppercase tracking-widest text-[#2C3E50]/60">In</div>
                  <div className="text-2xl font-black text-[#4FB3B8]" style={{ fontFamily: 'Fraunces, serif' }}>
                    {s.duration}
                  </div>
                </div>
                <div className="rounded-xl p-3 text-center border-2 border-[#2C3E50]" style={{ background: s.accent }}>
                  <div className="text-[10px] font-black uppercase tracking-widest text-white/90">Now</div>
                  <div className="text-2xl font-black text-white" style={{ fontFamily: 'Fraunces, serif' }}>
                    {s.after}%
                  </div>
                </div>
              </div>

              <blockquote className="mt-6 text-lg text-[#2C3E50]/90 italic font-semibold leading-relaxed" style={{ fontFamily: 'Fraunces, serif' }}>
                &ldquo;{s.story}&rdquo;
              </blockquote>

              <div className="mt-6 inline-flex items-center gap-2 text-xs font-black uppercase tracking-widest text-[#2C3E50]/70">
                <TrendingUp size={14} className="text-[#4FB3B8]" strokeWidth={3} />
                +{s.after - s.before} percentage points improvement
              </div>
            </div>
          </div>
        </div>

        {/* Story picker grid */}
        <div className="mt-10 grid grid-cols-2 md:grid-cols-5 gap-4">
          {stories.map((st, i) => (
            <StoryCard key={st.name} s={st} active={i === idx} onClick={() => setIdx(i)} />
          ))}
        </div>

        <div className="mt-12 text-center">
          <a
            href="#register"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-[#2C3E50] text-white font-black border-2 border-[#2C3E50] paper-shadow-sm hover:bg-[#E64B2B] hover:border-[#E64B2B]"
          >
            Start your child&rsquo;s success story <ArrowUpRight size={18} strokeWidth={3} />
          </a>
        </div>
      </div>
    </section>
  );
}
